import { EventEmitter } from "nate-react-api-helpers";
import { createContext } from "react";
export const ListContext = /*#__PURE__*/ createContext({ pageSize: 100, offset: 0, search: "", count: 0, data: [], loadingStatus: new EventEmitter(), onReload: new EventEmitter(), setOffset: value => { }, setSearch: value => { }, reload: () => { }, showArchived: false, setShowArchived: value => { } });
